import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/sk.ts
var add = "Pridať";
var remove = "Odstrániť";
var removeAll = "Odstrániť všetko";
var incomplete = "Prepáčte, ale nie všetky polia sú vyplnené správne.";
var submit = "Odoslať";
var noFiles = "Nebol vybraný žiadny súbor";
var moveUp = "Posunúť hore";
var moveDown = "Posunúť dole";
var isLoading = "Načítavanie...";
var loadMore = "Načítať viac";
var next = "Ďalšie";
var prev = "Predošlý";
var addAllValues = "Pridajte všetky hodnoty";
var addSelectedValues = "Pridajte vybrané hodnoty";
var removeAllValues = "Odstrániť všetky hodnoty";
var removeSelectedValues = "Odstrániť vybrané hodnoty";
var chooseDate = "Vyberte dátum";
var changeDate = "Zmena dátumu";
var close = "Zavrieť";
var open = "Otvorené";
var accepted = function({
  name
}) {
  return `Prosím zaškrtnite ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} musí byť za ${date(args[0])}.`;
  }
  return `${sentence(name)} musí byť v budúcnosti.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} môže obsahovať iba písmená.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} môže obsahovať iba písmená a čísla.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} môže obsahovať iba písmená a medzery.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} musí obsahovať abecedné znaky.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} musí obsahovať písmená alebo číslice.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} musí obsahovať písmená alebo medzery.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} musí obsahovať symbol.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} musí obsahovať veľké písmená.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} musí obsahovať malé písmená.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} musí obsahovať čísla.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} musí byť symbol.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} môže obsahovať iba veľké písmená.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} môže obsahovať len malé písmená.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} musí byť pred ${date(args[0])}.`;
  }
  return `${sentence(name)} musí byť v minulosti.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Toto pole bolo nesprávne nakonfigurované a nemôže byť odoslané.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} musí byť medzi ${a} and ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} does not match.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} nie je platným dátumom, prosím, použite formát ${args[0]}`;
  }
  return "Toto pole bolo nesprávne nakonfigurované a nemôže byť odoslané.";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} musí byť medzi ${date(args[0])} a ${date(args[1])}`;
};
var email = "Prosím, zadajte platnú emailovú adresu.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} nekončí na ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} nie je povolená hodnota.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} musí mať najmenej jeden znak.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} musí byť menšie alebo rovné ako ${max2} znakov.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} by mala mať dĺžku ${max2} znakov.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} musí byť väčšie alebo rovné ako ${min2} znakov.`;
  }
  return `${sentence(name)} musí byť medzi ${min2} až ${max2} znakov.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} nie je povolená hodnota.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Nie je možné použiť viac než ${args[0]} ${name}.`;
  }
  return `${sentence(name)} musí byť menšie alebo rovné ako ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Nie sú povolené formáty súborov.";
  }
  return `${sentence(name)} musí byť typu: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Nemôže byť menej než ${args[0]} ${name}.`;
  }
  return `${sentence(name)} musí byť minimálne ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” nie je povolené hodnota pre ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} musí byť číslo.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" alebo ")} je potrebný.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} je povinné.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} nezačíná s ${list(args)}.`;
};
var url = function() {
  return `Zadajte platnú adresu URL.`;
};
var invalidDate = "Vybraný dátum je neplatný.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var sk_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, sk_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=sk.mjs.map